import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.991 1c.387 0 .7.285.7.636v.637h1.4c1.16 0 2.1.854 2.1 1.909v8.909c0 1.054-.94 1.909-2.1 1.909h-9.8c-1.16 0-2.1-.855-2.1-1.91V4.183c0-1.055.94-1.91 2.1-1.91h1.4v-.636c0-.351.313-.636.7-.636s.7.285.7.636v.637h4.2v-.637c0-.351.313-.636.7-.636m-6.3 2.545v.637c0 .351.313.636.7.636s.7-.285.7-.636v-.637h4.2v.637c0 .351.313.636.7.636s.7-.285.7-.636v-.637h1.4c.386 0 .7.285.7.637V6.09H2.59V4.18c0-.35.313-.636.7-.636zm9.1 3.819v5.727c0 .351-.314.636-.7.636h-9.8c-.387 0-.7-.285-.7-.636V7.364z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })